import React from "react";
import PropTypes from "prop-types";
import Input from "../../common/Input";
import SelectInput from "../../common/SelectInput";
import { STATUS } from "../../common/Const";
import { PARTICIPATION_STRATEGIES } from "../../billingEnrollment/billingEnrollmentTypes";
import PaymentSchedulePreview from "./PaymentSchedulePreview";

const labelForPerson = item => `${item.firstName || ""} ${item.lastName || ""}`.trim() || item.id;
const optionsForPeople = items => items.map(item => ({ value: item.id, text: labelForPerson(item) }));
const optionsForProducts = items => items.map(item => ({ value: item.id, text: item.name || item.id }));
const getProductById = (products, id) => products.find(product => product.id === id) || null;

function EnrollmentForm({
  clients,
  students,
  products,
  enrollment,
  errors,
  onChange,
  onSubmit,
  onCancel,
  status,
}) {
  const disabled = status === STATUS.SUBMITTING;
  const selectedProduct = getProductById(products, enrollment.productId) || enrollment.product || null;
  const usesSharedStudents = selectedProduct
    && selectedProduct.participationStrategy === PARTICIPATION_STRATEGIES.SHARED_STUDENTS;

  return (
    <form id="enrollment-form" onSubmit={onSubmit}>
      <h2 className="manage-title">Zapis</h2>
      <div className="form-row">
        <div className="col-md-4">
          <SelectInput
            label="Klient"
            name="clientId"
            value={enrollment.clientId || ""}
            defaultOption="Wybierz klienta"
            options={optionsForPeople(clients)}
            error={errors.clientId}
            onChange={onChange}
          />
        </div>
        <div className="col-md-4">
          <SelectInput
            label="Produkt"
            name="productId"
            value={enrollment.productId || ""}
            defaultOption="Wybierz produkt"
            options={optionsForProducts(products)}
            error={errors.productId}
            onChange={onChange}
          />
        </div>
        <div className="col-md-4">
          {usesSharedStudents ? (
            <div className="form-group">
              <span><strong>Uprawnieni studenci</strong></span>
              <div className="field mt-1">
                <select
                  name="eligibleStudentIds"
                  multiple
                  value={enrollment.eligibleStudentIds || enrollment.studentIds || []}
                  onChange={onChange}
                  className={`form-control ${errors.eligibleStudentIds ? "is-invalid" : ""}`}
                  aria-label="Uprawnieni studenci"
                >
                  {optionsForPeople(students).map(option => (
                    <option key={option.value} value={option.value}>
                      {option.text}
                    </option>
                  ))}
                </select>
                {errors.eligibleStudentIds && <div className="invalid-feedback">{errors.eligibleStudentIds}</div>}
              </div>
            </div>
          ) : (
            <SelectInput
              label="Student"
              name="studentIds"
              value={(enrollment.studentIds || enrollment.eligibleStudentIds || [])[0] || ""}
              defaultOption="Wybierz studenta"
              options={optionsForPeople(students)}
              error={errors.studentIds || errors.eligibleStudentIds}
              onChange={onChange}
            />
          )}
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <Input
            label="Start"
            name="startDate"
            type="date"
            value={enrollment.startDate || ""}
            error={errors.startDate}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <Input
            label="Termin pierwszej platnosci"
            name="firstPaymentDueDate"
            type="date"
            value={enrollment.firstPaymentDueDate || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <Input
            label="Oplata poczatkowa"
            name="initialFee"
            type="number"
            value={String(enrollment.initialFee || "")}
            onChange={onChange}
          />
        </div>
        <div className="col-md-3">
          <Input
            label="Materialy"
            name="materialsFee"
            type="number"
            value={String(enrollment.materialsFee || "")}
            onChange={onChange}
          />
        </div>
      </div>
      <PaymentSchedulePreview items={enrollment.paymentScheduleItems || []} />
      <div className="pt-4 row mx-0">
        <div className="ml-auto col-md-block">
          <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={disabled}>
            {disabled ? "Zapisywanie..." : "Zapisz"}
          </button>
        </div>
        <div className="col-md-block pl-2 pr-2">
          <button type="button" className="btn manage-button manage-teal-button btn-block" disabled={disabled} onClick={onCancel}>
            Powrot
          </button>
        </div>
      </div>
    </form>
  );
}

EnrollmentForm.propTypes = {
  clients: PropTypes.array.isRequired,
  students: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  enrollment: PropTypes.object.isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  status: PropTypes.string,
};

EnrollmentForm.defaultProps = {
  errors: {},
  onCancel: () => {},
  status: STATUS.IDLE,
};

export default EnrollmentForm;
